import { User } from '@ekkogmbh/apisdk';
import { ListItemText } from '@mui/material';
import PaginatedSelect from 'src/Common/Components/Forms/PaginatedSelect';
import useEkko from 'src/Common/Providers/EkkoProvider';

interface Props {
  user?: User;
  disabled?: boolean;
  onChange: (user?: User) => void;
}

export default function UserPicker({ user, disabled, onChange }: Props): React.JSX.Element {
  const { api } = useEkko();
  return (
    <PaginatedSelect
      label={'User'}
      value={user}
      disabled={disabled}
      fetchPaginatedItems={(pagination) => api.getUsers(pagination, true, true)}
      itemId={(u: User) => u.id}
      itemRender={(u: User) => <ListItemText primary={u.username} secondary={u.coordinate} />}
      onChange={(u) => onChange(u as User | undefined)}
    />
  );
}
